import "./ArrowDown.css";
import KeyboardDoubleArrowDownIcon from "@mui/icons-material/KeyboardDoubleArrowDown";

export default function ArrowDown() {
  return (
    <div className="action-style">
      <p className="btn-style">Scroll</p>
      <KeyboardDoubleArrowDownIcon />
    </div>
  );
}
